import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '24',
  height: '24',
  viewBox: '0 0 24 24'
}, [
  h('path', {
    d: 'M13.5 24h-3c-.3 0-.5-.2-.5-.5v-2.9c-.8-.2-1.7-.5-2.3-.8l-2 2c-.2.2-.5.2-.7 0L2.2 19c-.2 0-.2-.1-.2-.3s.1-.3.1-.4l2-2c-.3-.7-.6-1.5-.8-2.3H.5c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h2.9c.2-.8.5-1.7.8-2.3l-2-2C2 5.5 2 5.4 2 5.3s0-.3.1-.4l2.8-2.8c.2-.2.5-.2.7 0l2 2c.7-.3 1.6-.5 2.4-.7V.5c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5v2.9c.8.2 1.7.5 2.3.8l2-2c.2-.2.5-.2.7 0L21.8 5c.2 0 .2.2.2.3s0 .2-.1.3l-2 2c.3.7.6 1.5.8 2.3h2.9c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5h-2.9c-.2.8-.5 1.7-.8 2.3l2 2c.2.2.2.5 0 .7l-2.8 2.8c-.2.2-.5.2-.7 0l-2-2c-.7.3-1.5.6-2.3.8v2.9c-.1.4-.3.6-.6.6zM11 23h2v-2.7c0-.2.2-.4.4-.5.6-.1 2-.5 2.8-.9.2-.1.4-.1.6.1l1.9 1.9 2.1-2.1-1.9-1.9c-.2-.2-.2-.4-.1-.6.5-.7.8-2.2.9-2.8.1-.2.3-.4.5-.4H23v-2h-2.7c-.2 0-.4-.2-.5-.4-.1-.6-.5-2-.9-2.8-.1-.2-.1-.5.1-.6l1.9-1.9-2.1-2.1-1.9 1.9c-.2.2-.4.2-.6.1-.7-.5-2.2-.8-2.8-.9-.3-.2-.5-.4-.5-.7V1h-2v2.7c0 .2-.2.4-.4.5-.6.1-2 .5-2.8.9-.2.2-.4.2-.6 0L5.3 3.2 3.2 5.3l1.9 1.9c.2.2.2.4.1.6-.5.7-.8 2.2-.9 2.8-.1.2-.3.4-.6.4H1v2h2.7c.2 0 .4.2.5.4.1.6.5 2 .9 2.8.1.2.1.5-.1.6l-1.9 1.9 2.1 2.1 1.9-1.9c.2-.2.4-.2.6-.1.7.5 2.2.8 2.8.9.2.1.4.3.4.5V23z'
  }),
  h('path', {
    d: 'M12 17c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-9c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/nav-settings.es6.js